import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {LeaderboardService} from "../../services/leaderboard.service";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  user:any;
  userDetails:any;
  userAccounts: any[] = [];
  leaderboardLoaded: boolean = false;
  userRank: number | string = '-';
  topPoints: number = 0;
  pointsGapToTop: number = 0;

  constructor(
    private _auth: AuthService,
    private _leaderboardService: LeaderboardService
  ) { }

  ngOnInit(): void {
    // First try to get user from the BehaviorSubject's current value
    this.userDetails = this._auth.userValue;
    console.log('User details from userValue:', this.userDetails);

    if (this.userDetails && this.userDetails.id) {
      // If we have user details with ID, fetch the profile
      this.userData(this.userDetails.id);
      this.getLeaderboard();
    } else {
      // If not available from userValue, subscribe to user observable
      // This handles cases where user data might be loaded asynchronously
      this._auth.user.subscribe(user => {
        this.userDetails = user;
        console.log('User details from subscription:', this.userDetails);

        if (this.userDetails && this.userDetails.id) {
          this.userData(this.userDetails.id);
          this.getLeaderboard();
        } else {
          console.error('User details or user ID not available');
        }
      });
    }
  }

  userData(userId:any ){
    this._auth.userProfile(userId).subscribe(
      (data) => {
        this.user = data;
        console.log('this is the user data', this.user);
      },
      (error) => {
        console.error('Error fetching user profile:', error);
      }
    );
  }

  getLeaderboard() {
    this._leaderboardService.getAllUserAccounts(1, 5).subscribe(
      (data) => {
        const accounts = data?.userAccountsDto || data?.userAccountDtoList || [];
        if (accounts.length > 0) {
          this.userAccounts = accounts;
          this.leaderboardLoaded = true;
          this.topPoints = Number(this.userAccounts[0]?.points || 0);
          const me = this.userDetails?.username || this.userDetails?.userName;
          const myIndex = this.userAccounts.findIndex((ua: any) =>
            ua?.user?.userName === me || ua?.user?.username === me
          );
          this.userRank = myIndex >= 0 ? myIndex + 1 : '5+';
          const myPoints = Number(this.user?.userAccountDto?.points || 0);
          this.pointsGapToTop = Math.max(this.topPoints - myPoints, 0);
          console.log('Leaderboard data:', this.userAccounts);
        } else {
          this.userAccounts = [];
          this.leaderboardLoaded = true;
        }
      },
      (error) => {
        console.error('Error fetching leaderboard:', error);
      }
    );
  }

}
